import { createAction } from '@reduxjs/toolkit'

export const syncImages = createAction('marketing/syncImages')
export const copyImages = createAction('marketing/copyImages')
export const refreshImages = createAction('marketing/refreshImages')
